import { createListenerMiddleware } from "@reduxjs/toolkit";

import { clearCompany } from "@/store/slices/companySlice";
import { clearSelection, resetFilters } from "@/store/slices/eventsSlice";
import { logout, setCredentials } from "@/store/slices/userSlice";
import {
  clearCurrentEvent,
  clearPlatformEventMembers,
  clearEventContents,
} from "@/store/slices/eventsSlice";

/**
 * RTK Listener Middleware — the right place for cross-slice side-effects
 * that don't belong in components or thunks.
 *
 * NOTE: We intentionally do NOT import RootState/AppDispatch from @/store
 * here. That file imports this middleware, so importing back would create
 * a circular reference. The listeners below only need action creators from
 * individual slice files, which is perfectly safe.
 *
 * To add a new listener:
 *   listenerMiddleware.startListening({ ... })
 */
export const listenerMiddleware = createListenerMiddleware();

// ─── On login: persist token to localStorage ──────────────────────
listenerMiddleware.startListening({
  actionCreator: setCredentials,
  effect: ({ payload }) => {
    localStorage.setItem("fd:auth_token", payload?.tokens?.accessToken ?? "");
  },
});

// ─── On logout: clear all cross-slice state + localStorage ────────
listenerMiddleware.startListening({
  actionCreator: logout,
  effect: (_action, listenerApi) => {
    listenerApi.dispatch(clearCompany());
    listenerApi.dispatch(clearSelection());
    listenerApi.dispatch(resetFilters());
    listenerApi.dispatch(clearCurrentEvent());
    listenerApi.dispatch(clearPlatformEventMembers());
    listenerApi.dispatch(clearEventContents());
    localStorage.removeItem("fd:auth_token");
  },
});
